import React from "react";
import TimelineSection from "./TimelineSection";
import ChatBuddySection from "./ChatBuddySection";
import BuddyRequestsSection from "./BuddyRequestsSection";
import MessageComponent from "./MessageComponent";

import { useAtom } from "jotai";
import { gbMessageState } from "../../../components/shared/GlobalState";

const CenterStageSection = () => {
  const [showMessageComponent, setShowMessageComponent] =
    useAtom(gbMessageState);

  return (
    <>
      {showMessageComponent ? (
        <div className="mt-3 w-full">
          <MessageComponent />
        </div>
      ) : (
        <>
          <div className="w-full md:w-2/3">
            <TimelineSection />
          </div>
          <div className="hidden w-1/3 md:block">
            <BuddyRequestsSection />
            <div className="my-4"></div>
            <ChatBuddySection />
          </div>
        </>
      )}
    </>
  );
};

export default CenterStageSection;
